import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { goToMenu } from 'cart/actions/orderSettings';

import Drawer from 'base/components/Drawer';
import CartContainer from 'cart/containers/CartContainer';
import ModalContainer from 'base/containers/ModalContainer';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

class CartDrawer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  };

  handleClose = () => {
    this.props.dispatch(goToMenu());
  };

  render() {
    return (
      <ModalContainer>
        <Drawer handleClose={this.handleClose}>
          <CartContainer />
        </Drawer>
      </ModalContainer>
    );
  }
}

export default withGoogleLibraryLoaded(connect()(CartDrawer));
